import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showDetail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideDetail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lockLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unlockLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showGraphConfigPanel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hideGraphConfigPanel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	graphConfigPanelHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	referenceTypesHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'assets-object-graph.title',
		defaultMessage: 'Object graph',
		description: 'Title for the graph component which contains details about an CMDB object',
	},
	showDetail: {
		id: 'assets-object-graph.show-detail',
		defaultMessage: 'Show object details panel',
		description: 'Button label for showing extra detail about an CMDB object',
	},
	hideDetail: {
		id: 'assets-object-graph.hide-detail',
		defaultMessage: 'Hide object details panel',
		description: 'Button label for hiding extra detail about an CMDB object',
	},
	lockLayout: {
		id: 'assets-object-graph.lock-layout',
		defaultMessage: 'Lock node layout',
		description: 'Button label resetting CMDB object graph layout',
	},
	unlockLayout: {
		id: 'assets-object-graph.unlock-layout',
		defaultMessage: 'Unlock node layout',
		description: 'Button label unlocking CMDB object graph layout',
	},
	showGraphConfigPanel: {
		id: 'assets-object-graph.show-graph-config-panel',
		defaultMessage: 'Show graph configuration',
		description: 'Button label to show the object graph configuration panel',
	},
	hideGraphConfigPanel: {
		id: 'assets-object-graph.hide-graph-config-panel',
		defaultMessage: 'Hide graph configuration',
		description: 'Button label to hide the object graph configuration panel',
	},
	graphConfigPanelHeader: {
		id: 'assets-object-graph.graph-config-panel-header',
		defaultMessage: 'Graph configuration',
		description: 'Title text shown in a dropdown menu for the CMDB object graph configuration',
	},
	referenceTypesHeader: {
		id: 'assets-object-graph.reference-types-header',
		defaultMessage: 'Reference types',
		description:
			'Title text shown in a dropdown menu for the CMDB object graph configuration for the reference types list',
	},
});
export default messages;
